import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-finished',
  imports: [CommonModule],
  templateUrl: './finished.component.html',
  styles: [
    `
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes slideUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideUpDelayed {
        0% {
          opacity: 0;
          transform: translateY(30px);
        }
        50% {
          opacity: 0;
          transform: translateY(30px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .animate-fade-in {
        animation: fadeIn 1s ease-out;
      }

      .animate-slide-up {
        animation: slideUp 0.8s ease-out;
      }

      .animate-slide-up-delayed {
        animation: slideUpDelayed 1.2s ease-out;
      }
    `,
  ],
})
export class FinishedComponent implements OnChanges {
  @Output() onClose = new EventEmitter<void>();
  @Input() show = false;

  private readonly autoCloseDelay = 3000;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.hasShowPropertyChanged(changes)) {
      this.initializeAutoCloseTimer();
    }
  }

  close(): void {
    this.onClose.emit();
  }

  private hasShowPropertyChanged(changes: SimpleChanges): boolean {
    return changes['show'] !== undefined;
  }

  private initializeAutoCloseTimer(): void {
    setTimeout(() => {
      this.close();
    }, this.autoCloseDelay);
  }
}
